<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title class="title">Acción realizada :: <strong>Ver</strong></h2>
<br>
<mat-dialog-content>
  <div class="timeline">
    <div *ngFor="let item of data; let i = index" class="timeline-item" [ngClass]="{ 'left': i % 2 !== 0, 'right': i % 2 === 0 }">
      <div class="content">
        <h4 class="date">{{ item.fechaCambio | date: 'short' }}</h4>
        <p>
          <strong>Entidad:</strong> {{ item.tipoEntidad }} &bullet;
          <strong>Acción:</strong> {{ item.accion }}
        </p>
        <p><strong>Descripción:</strong> {{ item.descripcionCambio }}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end"></mat-dialog-actions>
